module.exports = __webpack_public_path__ + "static/media/course1.9b7e81ee.jpeg";